import React from "react";
import { bool, oneOf, string } from "prop-types";
import { classes } from "../utils/classes";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";

const Line = ({
	className = "",
	opacity = "",
	isGradient = false,
	utility = { ...utilityProps },
	spacing = { ...spacingProps },
}) => {
	return (
		<div
			className={classes(
				"line",
				opacity && `line--opacity-${opacity}`,
				isGradient && "line--gradient",
				...utilityClassName(utility),
				...spacingClassName(spacing),
				className,
			)}
		/>
	);
};

Line.propTypes = {
	className: string,
	opacity: oneOf([0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]),
	isGradient: bool,
	utility: utilityPropTypes,
	spacing: spacingPropTypes,
};

export default Line;
